import React, { useContext } from 'react';
import CodeableContext from 'contexts/CodeableContext';
import CodeContainer from 'projects/components/CodeContainer';

function ChatCodeContainer({ projectID }) {
    const {
        selectedExcerptId,
        selectedExcerptVisible
    } = useContext(CodeableContext);

    return <CodeContainer
        projectID={projectID}
        disabled={!selectedExcerptId || !selectedExcerptVisible}
    />
}

export default ChatCodeContainer;